import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../api.js';

/**
 * Nudge to add a payment method — shown only when billing is enabled for the
 * environment and the account has no card/bank on file yet.
 */
export function BillingPrompt() {
  const { client } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let active = true;
    client
      .getBilling()
      .then((b) => active && setShow(!!b.stripeEnabled && !b.card))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [client]);

  if (!show) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 dark:border-amber-900/60 dark:bg-amber-950/30">
      <div className="flex items-center gap-2.5 text-sm text-amber-800 dark:text-amber-200">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          className="shrink-0"
        >
          <path
            d="M3 7h18v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path d="M3 10h18" stroke="currentColor" strokeWidth="2" />
        </svg>
        <span>
          <span className="font-medium">Add a payment method</span> to enable billing — pay by card
          or bank (ACH).
        </span>
      </div>
      <Link
        to="/profile"
        className="shrink-0 rounded-lg bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-amber-700"
      >
        Add card or bank →
      </Link>
    </div>
  );
}
